import { render } from "./AppSidebarFooterItems.vue?vue&type=template&id=145ca913"
import script from "./AppSidebarFooterItems.vue?vue&type=script&lang=js"
export * from "./AppSidebarFooterItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__